import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { goToPage, setPercent, setEmailError, report, openWhatsAppChat, createWorkOrder, setServiceMessageID } from '../MovingBlockSlice';
import Error from '../Partials/Error/Error';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import { prepareNewWindowUrl } from '../../../../utilities/StringHelpers/StringHelpers';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { gtag4 } from '../../../../utilities/analytics/tracking';


const ErrorPage = (props) => {
  let iconType = "";
  let title = "";
  let subTitle = "";
  let isDisplayServiceCall = false;
  let hasDebt = false;
  let hasPaymentMethodIssue = false;
  let btnText = "";
  let urlType = "";
  let isDisplayWhatsApp = false;

  useEffect(() => {
    props.setPercent(45);
  }, []);

  function handleBtnClick() {
    if (isDisplayWhatsApp) {
      props.openWhatsAppChat();
      return;
    }
    if (urlType == "lobby") {
      props.context.navigateTo("/");
    }
    else if ("selfCare") {
      EpiContext.navigateTo(Config.lobbyUrl)
    }
  }

  function handleOnClickDebtPaymentLink() {
    googleAnalyticsReport('Moving_Step3_FinProblemPaymentButton', 'FinancialProblemPaymentButton', 'לעדכון חוב');
    props.report({ actionType: "Finance Message", status: "Ongoing", messageText: "Finance Message Page Button Clicked", products: props.products, param2: props.fullAddress, selectedProducts: props.selectedProducts, param4: props.selectedEntry?.infrastructure, param5: 'link clicked: debt' });
    prepareNewWindowUrl(props.debtPaymentLink, props.context);
  }

  function handleOnClickUpdatePaymentLink() {
    googleAnalyticsReport('Moving_Step3_FinProblemUpdatePaymentMethod', 'FinProblemUpdatePaymentMethod', 'לעדכון אמצעי תשלום');
    props.report({ actionType: "Finance Message", status: "Ongoing", messageText: "Finance Message Page Button Clicked", products: props.products, param2: props.fullAddress, selectedProducts: props.selectedProducts, param4: props.selectedEntry?.infrastructure, param5: 'link clicked: payment' });
    prepareNewWindowUrl(props.updatePaymentLink, props.context);
  }

  async function callBackService() {
    if (props.workOrderDetails.isOpen) {
      props.showAppLoader();
      let openWorkOrder = await props.createWorkOrder(props.workOrderDetails);
      props.hideAppLoader();
      if (openWorkOrder.payload.isSuccess) {
        props.setServiceMessageID('CALLBACK_SUCCESS');
        props.goToPage("serviceMessagesPage");
      }
    } else {//כבר יש ללקוח הו"ע פתוחה
      props.setServiceMessageID('CALLBACK_SUCCESS');
      props.goToPage("serviceMessagesPage");
    }
  }

  switch (props.errorId) {
    case "GENERAL_ERROR":
      isDisplayWhatsApp = props.activityTime;
      iconType = props.activityTime ? "whatsapp" : "error";
      title = props.activityTime ? "נשאר לסגור כמה פרטים ולהשלים את התהליך" : "מצטערים, משהו השתבש והתהליך לא הושלם";
      subTitle = props.activityTime ? "נמשיך מפה עם מומחה שלנו ב-Whatsapp" : "נציגנו יחזור אליכם בהקדם האפשרי כדי לסיים את התהליך";
      isDisplayServiceCall = props.activityTime ? false : true;
      btnText = props.activityTime ? "נמשיך ב-WhatsApp" : "חזרה לעמוד הראשי";
      urlType = "lobby";
      googleAnalyticsEndOfProcess();
      break;
    case "GENERAL_ERROR_1":
      iconType = "error";
      title = "מצטערים, משהו השתבש והתהליך לא הושלם";
      subTitle = "";
      isDisplayServiceCall = true;
      btnText = "חזרה לעמוד הראשי";
      urlType = "lobby";
      googleAnalyticsEndOfProcess();
      break;
    case "HAS_DEBT_AND_PAYMENT_METHOD_ISSUE":
      iconType = "errorPayment";
      title = "מצטערים, לא ניתן להשלים את הפעולה!";
      subTitle = `לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך ב${window.Config.brand_Name_HE} ולשלם את החוב.`;
      hasDebt = true;
      hasPaymentMethodIssue = true;
      btnText = "לאיזור האישי";
      urlType = "selfCare";
      googleAnalyticsReport('Moving_Step3_FinProblemPage', 'FinancialProblemPage');
      break;
    case "HAS_DEBT_ISSUE":
      iconType = "errorPayment";
      title = "מצטערים, לא ניתן להשלים את הפעולה!";
      subTitle = "לפני שנמשיך בתהליך, עליך לשלם את החוב.";
      hasDebt = true;
      btnText = "לאיזור האישי";
      urlType = "selfCare";
      googleAnalyticsReport('Moving_Step3_FinProblemPage', 'FinancialProblemPage');
      break;
    case "HAS_PAYMENT_METHOD_ISSUE":
      iconType = "errorPayment";
      title = "מצטערים, לא ניתן להשלים את הפעולה!";
      subTitle = `לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך ב${window.Config.brand_Name_HE}.`;
      hasPaymentMethodIssue = true;
      btnText = "לאיזור האישי";
      urlType = "selfCare";
      googleAnalyticsReport('Moving_Step3_FinProblemPage', 'FinancialProblemPage');
      break;
  }

  function googleAnalyticsReport(event, action, buttonText = null) {
    if (buttonText) {
      gtag4({
        event: event,
        title: title,
        button: buttonText,
        step: '3',
        action: action,
        funnel_name: '1 - MovingWithProducts',
      });
    }
    else {
      gtag4({
        event: event,
        title: title,
        step: '3',
        action: action,
        funnel_name: '1 - MovingWithProducts',
      });
    }
  }

  function googleAnalyticsEndOfProcess() {
    if (props.isEndOfProcess) {
      if (props.movingWithTechnician) {
        gtag4({
          event: 'Moving_Step5_ErrorEndOfProcessPage_S4',
          title: title,
          error: props.workOrderDetails?.reason,
          step: '5',
          action: 'ErrorEndOfProcessPage_S4',
          funnel_name: '1 - MovingWithProducts'
        });
      }
      else {
        if (props.products?.length == 0) {
          gtag4({
            event: 'Moving_Step4_ErrorEndOfProcess_S3',
            title: title,
            error: props.workOrderDetails?.reason,
            step: '4',
            action: 'ErrorEndOfProcess_S3',
            funnel_name: '1 - MovingWithProducts'
          });
        }
        else {
          gtag4({
            event: 'Moving_Step3_EndOfProcessErrorPage',
            title: title,
            error: props.workOrderDetails?.reason,
            step: '3',
            action: 'EndOfProcessErrorPage',
            funnel_name: '2 - MovingWithoutProducts'
          });
        }
      }
    }
  }


  return (
    <>
      <ProgressLine percent={props.percent} />
      <Error
        title={title}
        subTitle={subTitle}
        iconType={iconType}
        hasPaymentMethodIssue={hasPaymentMethodIssue}
        hasDebt={hasDebt}
        isDisplayServiceCall={isDisplayServiceCall}
        onClickUpdatePaymentLink={handleOnClickUpdatePaymentLink}
        onClickDebtPaymentLink={handleOnClickDebtPaymentLink} />
      <MovingFooter
        onBtnClick={handleBtnClick}
        btnText={btnText}
        isDisplayWhatsApp={isDisplayWhatsApp}
        callBackService={callBackService}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    page: state.movingBlock.movingApartmentData.page,
    errorId: state.movingBlock.movingApartmentData.errorId,
    email: state.movingBlock.movingApartmentData.email,
    fullAddress: state.movingBlock.movingApartmentData.address?.fullAddress,
    debtPaymentLink: state.movingBlock.movingEpiData.debtPaymentLink?.value,
    updatePaymentLink: state.movingBlock.movingEpiData.updatePaymentLink?.value,
    products: state.movingBlock.movingApartmentData.products,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    selectedEntry: state.movingBlock.movingApartmentData.address.selectedEntry,
    activityTime: state.movingBlock.movingApartmentData.activityTime,
    workOrderDetails: state.movingBlock.movingApartmentData.workOrderDetails,
    movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,
    isEndOfProcess: state.movingBlock.movingApartmentData.isEndOfProcess,

  };
};

const mapDispatchToProps = { goToPage, setPercent, setEmailError, report, openWhatsAppChat, createWorkOrder, setServiceMessageID, showAppLoader, hideAppLoader };

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
